import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { Divider } from '@/app/components/divider';
import type { CompareHeaderCtaItemType } from '@/app/lcv/components/sections/compare/list/header-cta';
import { PRODUCT_COMPARE_DATA_GA, PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import { getProductUrlFromLcvModel, getRegisterUrlFromLcvModelCategory } from '@/app/lcv/components/sections/compare/utils';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { formatPrice } from '@/app/utils/format';
export const CompareListPriceCta = t0 => {
  const $ = _c(34);
  let category;
  let model;
  let rest;
  let selectedColor;
  if ($[0] !== t0) {
    ({
      model,
      category,
      selectedColor,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = category;
    $[2] = model;
    $[3] = rest;
    $[4] = selectedColor;
  } else {
    category = $[1];
    model = $[2];
    rest = $[3];
    selectedColor = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Divider className="mt-0" />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createDataAttributes({
      test: "price"
    });
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = (model.price ?? 0) + (selectedColor?.price || 0);
  let t4;
  if ($[7] !== t3) {
    t4 = formatPrice(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-body-1 font-noto-bold mb-4" {...t2}>{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== category) {
    t6 = getRegisterUrlFromLcvModelCategory(category);
    $[11] = category;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = createDataAttributes({
      test: PRODUCT_COMPARE_DATA_TEST.registerCta
    });
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== category) {
    t8 = createDataGA({
      click: true,
      eventName: PRODUCT_COMPARE_DATA_GA.main,
      text: "\u0E2A\u0E19\u0E43\u0E08\u0E23\u0E16",
      url: getRegisterUrlFromLcvModelCategory(category)
    });
    $[14] = category;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <Button href={t6} width="full" size="sm" {...t7} {...t8} className="mb-3">สนใจรถ</Button>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== model) {
    t10 = getProductUrlFromLcvModel(model);
    $[19] = model;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = createDataAttributes({
      test: PRODUCT_COMPARE_DATA_TEST.productCta
    });
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== model) {
    t12 = createDataGA({
      click: true,
      eventName: PRODUCT_COMPARE_DATA_GA.main,
      text: "\u0E14\u0E39\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14",
      url: getProductUrlFromLcvModel(model)
    });
    $[22] = model;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12) {
    t13 = <Button href={t10} variant="secondary" width="full" size="sm" {...t11} {...t12}>ดูรายละเอียด</Button>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t5 || $[29] !== t9) {
    t14 = <div className="mx-auto max-w-56 text-center">{t5}{t9}{t13}</div>;
    $[27] = t13;
    $[28] = t5;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== rest || $[32] !== t14) {
    t15 = <div {...rest} role="cell">{t1}{t14}</div>;
    $[31] = rest;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};